import styled from 'styled-components';
import PropTypes from 'prop-types';

const getPosition = ({ sticky }) => (sticky ? 'sticky' : 'static');

const StyledSidebarHeader = styled.header`
	flex: ${({ $isNew }) => ($isNew ? `0 0 auto` : `0 1 auto`)};
	position: ${getPosition};
	top: 0;
	left: 0;
`;

/**
 * Simple sticky (by default) sidebar header without styling
 */
const SimpleSidebarHeader = ({ children, className, sticky, isNew = false }) => (
	<StyledSidebarHeader sticky={sticky} className={className} $isNew={isNew}>
		{children}
	</StyledSidebarHeader>
);

SimpleSidebarHeader.propTypes = {
	sticky: PropTypes.bool
};

SimpleSidebarHeader.defaultProps = {
	sticky: true
};

export default SimpleSidebarHeader;
